import React from 'react';
import { ImageIcon } from 'lucide-react';
import { VideoPlayer } from './VideoPlayer';
interface HeroMockupProps {
  /** Video MP4 que se reproduce dentro de la laptop. */
  videoSrc?: string;
  /** Portada del video (opcional). */
  videoPoster?: string;
  /** Captura de pantalla móvil que se muestra dentro del iPhone. */
  mobileImageSrc?: string;
}

/**
 * Mockup premium: laptop con reproductor de video MP4 + iPhone con captura móvil.
 * Uso: <HeroMockup videoSrc="/videos/demo.mp4" mobileImageSrc="/imagenes/movil.png" />
 */
export function HeroMockup({
  videoSrc,
  videoPoster,
  mobileImageSrc
}: HeroMockupProps) {
  return <div className="relative pl-0 sm:pl-8 lg:pl-14" data-id="element-158" data-mp="1n96tdaj1cxcu">
      {/* Glow naranja-rojo sutil detrás del contenedor de video */}
      <div aria-hidden="true" className="pointer-events-none absolute inset-x-4 top-2 h-48 rounded-[3rem] bg-[#FF4A1C]/25 blur-[90px] sm:inset-x-10" data-id="element-159" data-mp="1r74kiiwd9tiv" />
      <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-1/3 h-40 w-3/4 -translate-x-1/2 rounded-full bg-[#FF7A45]/12 blur-[70px]" data-id="element-160" data-mp="1i77rk52y28i0" />

      {/* Laptop con reproductor de video */}
      <div className="relative rounded-t-2xl border border-white/10 bg-ink-800 p-2.5 shadow-glow-lg" data-id="element-161" data-mp="30akz2ut0nzs9">
        <div className="flex items-center gap-1.5 pb-2 pl-1" data-id="element-162" data-mp="3e5vs02npaatz">
          <span aria-hidden="true" className="h-2 w-2 rounded-full bg-white/20" data-id="element-163" data-mp="39age5app0exk" />
          <span aria-hidden="true" className="h-2 w-2 rounded-full bg-white/20" data-id="element-164" data-mp="2lissp8b79w2o" />
          <span aria-hidden="true" className="h-2 w-2 rounded-full bg-neon/60" data-id="element-165" data-mp="2hiire8ycrtu5" />
          <span className="ml-3 truncate text-[10px] text-mist-dim" data-id="element-166" data-mp="2v9dq4sf50uk0">yennidigital.com</span>
        </div>

        <VideoPlayer src={videoSrc} poster={videoPoster} data-id="element-167" data-mp="2qinjzcyw0no9" />
      </div>
      <div aria-hidden="true" className="mx-auto h-3 w-[108%] max-w-none -translate-x-[4%] rounded-b-xl border border-t-0 border-white/10 bg-ink-700" data-id="element-168" data-mp="2qgkmk7vens9i" />

      {/* iPhone: contenedor exclusivo para captura de pantalla móvil */}
      <div className="absolute -bottom-8 right-0 w-24 rounded-[1.25rem] border border-neon/40 bg-ink-900 p-1.5 shadow-glow sm:w-28 lg:-right-4 lg:w-32" data-id="element-169" data-mp="1rn2hbgprdqf">
        <div className="relative aspect-[9/19] overflow-hidden rounded-[1rem] border border-white/5 bg-ink-800" data-id="element-170" data-mp="6nva83sl04nk">
          <div aria-hidden="true" className="absolute left-1/2 top-1.5 z-10 h-1 w-8 -translate-x-1/2 rounded-full bg-black/60" data-id="element-171" data-mp="gfrnim38o1cd" />
          {mobileImageSrc ? <img src={mobileImageSrc} alt="Captura de la versión móvil de la página web" className="h-full w-full object-cover object-top" loading="lazy" decoding="async" data-id="element-172" data-mp="3ezq5sxgv595j" /> : <div className="flex h-full flex-col items-center justify-center gap-2 px-3 text-center" data-id="element-173" data-mp="3sypqju1993wf">
              <span className="grid h-8 w-8 place-items-center rounded-full border border-neon/40 bg-neon/10 text-neon" data-id="element-174" data-mp="1452gvii9etgh">
                <ImageIcon className="h-3.5 w-3.5" aria-hidden="true" strokeWidth={1.5} data-id="element-175" data-mp="188s4a4n774zx" />
              </span>
              <span className="text-[9px] leading-tight text-mist-dim" data-id="element-176" data-mp="2oncw500mvzcw">
                Captura móvil
                <br data-id="element-177" data-mp="2jweg81jk53a6" />
                9:19
              </span>
            </div>}
        </div>
      </div>
    </div>;
}